// @ts-nocheck

export const localeCodes =  []
export const localeLoaders = {}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/7668d44f" /* webpackChunkName: "config_i18n_46config_46ts_7668d44f" */)
]
export const normalizedLocales = []

